/****************************************************
 * Module Name:  paymentModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Constants from "../../utility/constants";
import { Box, TextField, Button } from "@mui/material";
import TabMenuSnackbar from "../common/tabMenuSnackbar";
import logo from '../../images/pansuriya.jpg';
import { useEffect } from "react";
import Utility from "../../utility/utility";
import { LoadingButton } from "@mui/lab";
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';

function PaymentModal({
  show,
  setShow,
  handleValidation,
  handleSave,
  sourceData,
  loading
}) {
  const [amount, setAmount] = useState("");
  const [showError, setShowError] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [pendingAmount, setPendingAmount] = useState("");

  useEffect(() => {
    calculatePendingAmount();
  }, []);

  const calculatePendingAmount = () => {
    let sumPendingAmount = 0;
    sourceData.map((data) => {
      sumPendingAmount += data.pendingamount;
      return true;
    });
    setPendingAmount(sumPendingAmount);
  }

  const prepareData = () => {
    let dataArray = [];
    let enteredAmount = amount;
    for (let i = 0; i < sourceData.length; i++) {
      if (enteredAmount === 0) break;
      let currentData = sourceData[i];
      if (enteredAmount > currentData.pendingamount) {
        let obj = {
          commissionid: currentData.id,
          paidamount: currentData.pendingamount,
        };
        dataArray.push(obj);
        enteredAmount -= currentData.pendingamount;
      } else {
        let obj = {
          commissionid: currentData.id,
          paidamount: enteredAmount,
        };
        dataArray.push(obj);
        enteredAmount = 0;
      }
    }
    return dataArray;
  };

  const saveHandler = () => {
    let data = prepareData();
    if (handleSave) {
      if (handleValidation) {
        if (handleValidation(data)) {
          //need to add labId here and in the parent component if need for validation
          handleSave(data);
        } else {
          setShowError(true);
        }
      } else {
        handleSave(data);
      }
    }
  };

  const closeErrorDialog = () => {
    setShowError(false);
  };

  const handleClose = () => {
    setShow(false);
  };
  return (
    <div>
      <TabMenuSnackbar
        show={showError}
        message={
          <Box>
            mark report received validation Failed
            <br /> Please enter correct data
          </Box>
        }
        variant={"error"}
        autoHide={false}
        handleClose={closeErrorDialog}
        title="Validation Failure"
      />
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={true}
        size="lg"
        centered
        enforceFocus={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <img
              src={logo}
              height="40pt"
              width="40pt"
              alt={Constants.COMPANY_SITE}
            />
            &nbsp;&nbsp;Add amount to pay
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Box>
            Payable Amount (USD) : {Utility.ConvertNumberWithSpecifiedDigits(pendingAmount)}
          </Box>
          <Box sx={{ display: "flex", gap: "20px", mt: 2 }}>
            <Form.Label className="mt-2">Amount</Form.Label>
            <TextField
              id="outlined-multiline-static"
              label="Enter Amount"
              fullWidth
              value={amount}
              helperText={errorMsg}
              error={errorMsg.length > 0}
              onChange={(e) => {
                setAmount(e.target.value)
                setErrorMsg(Utility.CheckisNumberNegative(e.target.value) || (e.target.value > pendingAmount)
                  ? "Amount should be positive and not more than payable amount"
                  : "")
              }}
            />
          </Box>
        </Modal.Body>
        <Modal.Footer>
          <LoadingButton
            loading={loading}
            loadingPosition="start"
            startIcon={<AttachMoneyIcon />}
            variant="contained"
            onClick={saveHandler}
            type="Submit"
            sx={{ mr: 3 }}
            disabled={!amount || errorMsg.length > 0}
          >
            Pay
          </LoadingButton>
          <Button
            variant="contained"
            color="error"
            onClick={handleClose}
            sx={{ mr: 2 }}
            disabled={loading}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default PaymentModal;
